var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 26,
    rx: 10,
    fill: "#currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2857 5H7.71429C7.3192 5 7 5.325 7 5.72727V20.2727C7 20.675 7.3192 21 7.71429 21H26.2857C26.6808 21 27 20.675 27 20.2727V5.72727C27 5.325 26.6808 5 26.2857 5ZM25.3929 7.51818V19.3636H8.60714V7.51818L7.99107 7.02955L8.8683 5.88182L9.82366 6.63864H24.1786L25.1339 5.88182L26.0112 7.02955L25.3929 7.51818ZM24.1786 6.63636L17 12.3182L9.82143 6.63636L8.86607 5.87955L7.98884 7.02727L8.60491 7.51591L16.2299 13.5523C16.4492 13.7257 16.719 13.8199 16.9967 13.8199C17.2743 13.8199 17.5441 13.7257 17.7634 13.5523L25.3929 7.51818L26.0089 7.02955L25.1317 5.88182L24.1786 6.63636Z",
    fill: "#currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4574cc111f2f95b753cba0414d69a58b.svg";
export { ForwardRef as ReactComponent };